<template>
  <w-icon-wrapper icon-name='work-filter-icon'>
    <path
      id='_42_Filter_Icon'
      d='M20.22,2.013l-6.857,9.849-.358.513v8.183l-2.011.667V12.38l-.353-.511-6.763-9.8L20.22,2.013M24.067,0,.067.079,8.983,13V24l6.034-2V13l9.05-13Z'
      data-name='42 Filter_Icon'
      fill='currentColor'
      transform='translate(-0.067)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconFilter' };
</script>
